import {
  Pipe,
  PipeTransform,
  ChangeDetectorRef,
  NgZone,
  OnDestroy,
} from "@angular/core";
import { DateTimeService } from "../_utility/date-time.service";

@Pipe({
  name: "localDate",
  pure: true,
})
export class LocalDatePipe implements PipeTransform {
  constructor(private dateTimeService: DateTimeService) {}

  transform(value: string | Date, format?: string): string | null {
    if (!value) return null;
    return this.dateTimeService.format(value, format);
  }
}

@Pipe({
  name: "timeAgo",
  pure: false,
})
export class TimeAgoPipe implements PipeTransform, OnDestroy {
  private timer: any;

  constructor(
    private dateTimeService: DateTimeService,
    private cd: ChangeDetectorRef,
    private ngZone: NgZone,
  ) {}

  transform(value: string | Date): string {
    this.clearTimer();
    if (!value) return "";

    const past = this.dateTimeService.toLocalDate(value);
    if (!past) return "";

    const now = new Date();
    const diffMs = now.getTime() - past.getTime();
    const seconds = Math.floor(diffMs / 1000);
    const timeToUpdate = this.getUpdateInterval(seconds);

    this.ngZone.runOutsideAngular(() => {
      this.timer = setTimeout(() => {
        this.ngZone.run(() => this.cd.markForCheck());
      }, timeToUpdate);
    });

    return this.dateTimeService.timeAgo(value);
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  private clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  }

  private getUpdateInterval(seconds: number): number {
    if (seconds < 60) return 1000;
    if (seconds < 3600) return 60000;
    if (seconds < 86400) return 3600000;
    return 0;
  }
}
